import {api} from 'services/api';
import {ProjectAttachment} from 'types/attachements';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const getProjectAttachments = api.injectEndpoints({
  endpoints: builder => ({
    getProjectAttachments: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `projects/${params.id}/attachements`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<Array<ProjectAttachment>>;

export const {useGetProjectAttachmentsQuery} = getProjectAttachments;
